import Vue from 'vue';
import VueRouter from 'vue-router';

// 这一部分包含了对vue功能的重写
const confirm = Vue.prototype.$confirm;
const confirmOptions = {
    content: $t('public.tip_confirm'),
    title: $t('public.prompt'),
    option: {
        confirmButtonText: $t('public.btn_confirm'),
        cancelButtonText: $t('public.btn_cancel'),
        type: 'warning'
    }
};
/**
 * Vue 确认框的重写 添加了默认参数
 * @param {String} content 提示框内容
 * @param {String} title 提示框标题
 * @param {Object} option 提示框参数
 */
Vue.prototype.$confirm = function(content, title, option = {}) {
    confirmOptions.content = content || confirmOptions.content;
    confirmOptions.title = title || confirmOptions.title;
    confirmOptions.option = { ...confirmOptions.option, ...option };
    return confirm(confirmOptions.content, confirmOptions.title, confirmOptions.option);
};

// 解决路由跳转报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);

    return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);

    return originalReplace.call(this, location).catch(err => err);
};
